import { GeoService } from "./Geo";

export const $geo = new GeoService();
